module.exports = __webpack_public_path__ + "img/AFMS-ProfileDriver.ea07db10.png";